export default {
    OPEN_RESUME_QUALITY_FEEDBACK_MODAL(state) {
        state.isResumeQualityFeedbackModalOpen = true;
    },

    CLOSE_RESUME_QUALITY_FEEDBACK_MODAL(state) {
        state.isResumeQualityFeedbackModalOpen = false;
    },
};
